import React from "react";
import { useFormState } from "react-final-form";
import { motion, AnimateSharedLayout } from "framer-motion";

import RadioBlock from "../../components/RadioBlock";
import { Error } from "../../components/Validation";
import { fadeStart, fadeEnd, itemVariants } from "../../animate/helpers";

const OneBedroom = "assets/images/one-bedroom.png";
const TwoBedroom = "assets/images/two-bedrooms.png";
const ThreeBedroom = "assets/images/three-bedrooms.png";
const FourBedroom = "assets/images/four-bedrooms.png";

const DwellingSize = () => {
  const formState = useFormState();
  const selected = formState.values.move_size;
  return (
    <>
      <motion.div variants={itemVariants}>
        <label className="form-group__header header-label" htmlFor="move_size">
          I have ...
        </label>
      </motion.div>
      <AnimateSharedLayout>
        <motion.div
          className="radio-row"
          variants={{
            hidden: fadeStart,
            show: {
              ...fadeEnd,
              transition: {
                staggerChildren: 0.1,
                staggerDirection: -1,
              },
            },
          }}
          initial="hidden"
          animate="show"
        >
          <motion.div variants={itemVariants}>
            <RadioBlock
              title="a few items"
              image={OneBedroom}
              name="move_size"
              value="Few"
              isSelected={selected === "Few"}
            />
          </motion.div>
          <motion.div variants={itemVariants}>
            <RadioBlock
              title="2 bedrooms"
              image={TwoBedroom}
              name="move_size"
              value="2BR"
              isSelected={selected === "2BR"}
            />
          </motion.div>
          <motion.div variants={itemVariants}>
            <RadioBlock
              title="3 bedrooms"
              image={ThreeBedroom}
              name="move_size"
              value="3BR"
              isSelected={selected === "3BR"}
            />
          </motion.div>
          <motion.div variants={itemVariants}>
            <RadioBlock
              title="4+ bedrooms"
              image={FourBedroom}
              name="move_size"
              value="4BR"
              isSelected={selected === "4BR"}
            />
          </motion.div>
        </motion.div>
      </AnimateSharedLayout>

      <Error name="move_size" />
    </>
  );
};

export default DwellingSize;
